import { AlertifyService } from 'ccc-commons/core';
import {
  Component,
  OnInit,
  ViewChild,
  EventEmitter,
  Output, ElementRef
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AccountsService } from 'src/app/core/services/accounts.service';

@Component({
  selector: 'app-email-modal',
  templateUrl: './email-modal.component.html',
  styleUrls: ['./email-modal.component.scss']
})

export class EmailModalComponent implements OnInit {
  @Output()
  updateEmail = new EventEmitter<boolean>();

  @ViewChild('content')
  content: NgbModal;
  @ViewChild('emailInput')
  emailInput!: ElementRef<HTMLInputElement>;

  modal: any;
  accountForm: FormGroup;
  idAccount = '';
  emailAccount = '';
  isLoading = false;

  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder,
    private accountsService: AccountsService,
    private alertify: AlertifyService
  ) {}

  ngOnInit() {
    this.accountForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  open(userId: string, userEmail: string) {
    this.idAccount = userId;
    this.emailAccount = userEmail;
    this.accountForm.controls.email.setValue(this.emailAccount);

    this.modal = this.modalService.open(this.content, {
      centered: true,
      windowClass: 'animated faster zoomIn modal-custom ccc-new-modal',
      size: 'lg',
      backdrop: 'static'
    });
    setTimeout(() => {
      this.emailInput.nativeElement.focus();
    });
  }

  onDismiss() {
    this.modal.dismiss();
  }

  get registerFormControl() {
    return this.accountForm.controls;
  }

  onSubmit() {
    if (this.accountForm.valid) {
      this.isLoading = true;
      this.accountsService
        .updateEmailAccount(this.idAccount, this.accountForm.get('email').value)
        .subscribe(
          resp => {
            this.alertify.success(' Email updated successfully');
            this.modal.close();
            this.isLoading = false;
            this.updateEmail.emit(true);
          },
          error => {
            let message = ' ';
            const errors = error.error;
            if (Array.isArray(errors.message)) {
              for (const msg of errors.message) {
                for (const err of msg.errors) {
                  message += err.charAt(0).toUpperCase() + err.slice(1) + '\n';
                }
              }
            } else if (errors.message) {
              message += errors.message;
              this.alertify.error(message);
              this.updateEmail.emit(false);
            }
            this.isLoading = false;
          }
        );
    }
  }
}
